import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import actions from '../../actions';
import sendFileIcon from '../../static/images/send_file.png';
import config from '../../config';

const InputContainerStyle = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 18px;
    width: 100%;
    height: 180px;
    background: #ffffff;
`;
const TextAreaStyle = styled.textarea`
    display: block;
    margin-bottom: 10px;
    width: 284px;
    height: 84px;
    background: rgba(250, 250, 250, 1);
    border: none;
    border-radius: 2px;
`;
const SendButton = styled.button`
    display: inline-block;
    align-self: flex-end;
    width: 66px;
    height: 28px;
    background: ${props => (props.disabled ? 'rgba(212,212,212,1)' : '#2D80F1')};
    border-radius: 2px;
    border: none;

    font-size: 12px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 17px;
    text-align: center;
`;
const SendFile = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-self: flex-start;
    margin-bottom: 12px;
`;
const SendFileButton = styled.button`
    display: inline-block;
    padding: 4px;
    background-color: transparent;
    border: none;
    font-size: 18px;
    line-height: 1;

    & > * {
        cursor: pointer;
    }

    & > label > img {
        width: 21px;
        height: 18px;
    }
`;
const CustomButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding: 0;
    margin: 0;
    height: 26px;
    max-width: 50%;
    overflow: hidden;
`;

class InputEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: '',
            fileToSend: null,
        };
    }

    sendTextMsg = () => {
        const { type, scene, to, isRobot = false, invalid = false, invalidHint = '' } = this.props;
        const { message: rawMessage } = this.state;

        if (invalid) {
            alert(invalidHint);
        } else {
            if (/^\s*$/.test(rawMessage)) {
                alert('请不要发送空消息');
            } else if (rawMessage.length > 800) {
                alert('请不要超过800个字');
            } else {
                const message = rawMessage.trim();
                if (type === 'session') {
                    // 如果是机器人
                    if (isRobot) {
                        // this.props.dispatch({
                        //   type: 'sendRobotMsg',
                        //   payload: {
                        //     type: 'text',
                        //     scene: scene,
                        //     to: to,
                        //     robotAccid: to,
                        //     // 机器人后台消息
                        //     content: message,
                        //     // 显示的文本消息
                        //     body: message
                        //   }
                        // })
                    } else {
                        let robotAccid = '';
                        // let robotText = ''
                        //
                        // let atUsers = message.match(/@[^\s@$]+/g)
                        // if (atUsers) {
                        //   for (let i = 0; i < atUsers.length; i++) {
                        //     let item = atUsers[i].replace('@', '')
                        //     if (this.robotInfosByNick[item]) {
                        //       robotAccid = this.robotInfosByNick[item].account
                        //       robotText = (message + '').replace(atUsers[i], '').trim()
                        //       break
                        //     }
                        //   }
                        // }
                        if (robotAccid) {
                            // if (robotText) {
                            //   this.props.dispatch({
                            //     type: 'sendRobotMsg',
                            //     payload: {
                            //       type: 'text',
                            //       scene: scene,
                            //       to: to,
                            //       robotAccid,
                            //       // 机器人后台消息
                            //       content: robotText,
                            //       // 显示的文本消息
                            //       body: message
                            //     }
                            //   })
                            // } else {
                            //   this.props.dispatch({
                            //     type: 'sendRobotMsg',
                            //     payload: {
                            //       type: 'welcome',
                            //       scene: scene,
                            //       to: to,
                            //       robotAccid,
                            //       // 显示的文本消息
                            //       body: message
                            //     }
                            //   })
                            // }
                        } else {
                            this.props.sendMsg({
                                type: 'text',
                                scene: scene,
                                to: to,
                                text: message,
                            });
                        }
                    }
                } else if (type === 'chatroom') {
                    // let robotAccid = ''
                    // let robotText = ''
                    //
                    // let atUsers = message.match(/@[^\s@$]+/g)
                    // if (atUsers) {
                    //   for (let i = 0; i < atUsers.length; i++) {
                    //     let item = atUsers[i].replace('@', '')
                    //     if (this.robotInfosByNick[item]) {
                    //       robotAccid = this.robotInfosByNick[item].account
                    //       robotText = (message + '').replace(atUsers[i], '').trim()
                    //       break
                    //     }
                    //   }
                    // }
                    // if (robotAccid) {
                    //   if (robotText) {
                    //     this.props.dispatch('sendChatroomRobotMsg', {
                    //       type: 'text',
                    //       robotAccid,
                    //       // 机器人后台消息
                    //       content: robotText,
                    //       // 显示的文本消息
                    //       body: message
                    //     })
                    //   } else {
                    //     this.$store.dispatch('sendChatroomRobotMsg', {
                    //       type: 'welcome',
                    //       robotAccid,
                    //       // 显示的文本消息
                    //       body: message
                    //     })
                    //   }
                    // } else {
                    //   this.$store.dispatch('sendChatroomMsg', {
                    //     type: 'text',
                    //     text: message
                    //   })
                    // }
                }
                this.setState({ message: '' });
            }
        }
    };

    sendFileMsg = e => {
        const { type, scene, to, isRobot = false, invalid = false, invalidHint = '' } = this.props;
        const fileToSend = e.target.files[0] || null;

        // if (invalid) {
        //   alert(invalidHint)
        //   return
        // }
        if (fileToSend) {
            // if (type === 'session') {
            this.props.sendFileMsg({
                scene,
                to,
                fileInput: document.getElementById('wusong-im-send-file-input'),
            });
            // } else if (type === 'chatroom') {
            // this.props.dispatch({
            //   type: 'sendChatroomFileMsg',
            //   payload: {
            //     fileInput: fileToSend
            //   }
            // })
            // }
        }
    };

    render() {
        const { customerServiceAccount, to } = this.props;
        return (
            <InputContainerStyle>
                <SendFile>
                    <SendFileButton>
                        <label htmlFor="wusong-im-send-file-input">
                            <img src={sendFileIcon} alt="" />
                        </label>
                    </SendFileButton>
                    <input
                        type="file"
                        id="wusong-im-send-file-input"
                        hidden="hidden"
                        onChange={this.sendFileMsg}
                        title="SEND FILE"
                    />
                    <CustomButtonContainer className="wusong-im-btn-custom">
                        {customerServiceAccount === to ? null : this.props.btnCustomComponent}
                    </CustomButtonContainer>
                </SendFile>
                <TextAreaStyle
                    type="text"
                    name="content"
                    value={this.state.message}
                    resize="none"
                    onChange={e => {
                        this.setState({ message: e.target.value });
                    }}
                    maxLength="800"
                    placeholder="请输入消息"
                />
                <SendButton onClick={this.sendTextMsg}>发送</SendButton>
            </InputContainerStyle>
        );
    }
}

export default connect(
    store => {
        let { customerServiceAccount } = store[config.reduxStoreName];
        return {
            customerServiceAccount,
        };
    },
    {
        sendMsg: actions.sendMsg,
        sendFileMsg: actions.sendFileMsg,
    }
)(InputEditor);
